/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_Last_ModifiedInputs */



/**
* | output |
* | --- |
* | "Last Modified" |
*
* @param {Explorer_Info_Property_Last_ModifiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_last_modified = /** @type {((inputs?: Explorer_Info_Property_Last_ModifiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_Last_ModifiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Derniere modification")
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzte Änderung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultima modifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Последнее изменение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Última modificación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最后修改日期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最終更新日")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम बार संशोधित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Última modificação")
	return /** @type {LocalizedString} */ ("Last Modified")
});